import { useDebounce } from '@uidotdev/usehooks';
import { useAtomValue } from 'jotai';
import { sessionListSearchValueAtom } from './atoms';

export const SESSION_SEARCH_DEBOUNCE_MS = 250;

export const useDebouncedSessionSearchValue = () => {
  const searchValue = useAtomValue(sessionListSearchValueAtom);
  return useDebounce(searchValue, SESSION_SEARCH_DEBOUNCE_MS);
};
